import { Power1, Power3 } from 'gsap';
import Preset from '../Preset';
import Curve from '../../graphics/Curve';

const DEFAULT_SECTIONS = 8;

export default class Stacked extends Preset {
  constructor(app, sections = DEFAULT_SECTIONS) {
    super({ app, isFullScreen: true });

    this.sections = sections;
    this.curves = [];
    for (let i = 0; i < sections; i++) {
      this.curves.push(new Curve());
    }
  }

  update(model) {
    super.update(model);

    const { x, y, width, height } = this.root;
    const thirdDuration = model.duration / 3;
    const sixthDuration = model.duration / 6;

    this.curves.forEach((curve, index) => {
      curve.color = this.primaryColor.clone();
      curve.alpha = 0;
      curve.thickness = height / this.sections;

      const indexScale = index / this.sections;
      const finalY = y + height - height * indexScale - curve.thickness / 2;

      curve.from.x = x - curve.thickness;
      curve.from.y = finalY - height;
      curve.to.x = x + width + curve.thickness;
      curve.to.y = curve.from.y;

      curve.curvature = 0;

      this.animate(curve)
        .to(
          {
            alpha: this.primaryColor.getAlpha(),
            duration: thirdDuration,
            ease: Power1.easeOut,
          },
          sixthDuration * indexScale
        )
        .to(
          {
            curvature: 0.3,
            duration: sixthDuration,
            ease: Power3.easeIn,
          },
          sixthDuration * indexScale
        )
        .to(
          {
            curvature: 0,
            duration: sixthDuration,
            ease: Power3.easeOut,
          },
          sixthDuration + sixthDuration * indexScale
        )
        .reverseOut();

      this.animate(curve.from)
        .to(
          {
            y: finalY,
            duration: sixthDuration,
            ease: Power3.easeOut,
          },
          sixthDuration + sixthDuration * indexScale
        )
        .reverseOut();

      this.animate(curve.to)
        .to(
          {
            y: finalY,
            duration: sixthDuration,
            ease: Power3.easeOut,
          },
          sixthDuration + sixthDuration * indexScale
        )
        .reverseOut();
    });
  }

  render() {
    super.render();
    this.curves.forEach((curve) => curve.draw(this.graphics));
  }
}
